import React from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { orderColumn } from './columns';
import { toast } from 'react-toastify';
import { Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getAllOrderAsync } from './OrderStore/orderStoreSlice';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';

const STATUS_OPTION = [
  { label: 'Pending', value: 'pending' },
  { label: 'Paid', value: 'paid' },
  { label: 'Cancelled', value: 'cancelled' },
];

const Orders = () => {
  const [page, setPage] = React.useState(1);
  const [status, setStatus] = React.useState('pending');
  // const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const { Order } = useSelector((state) => {
    const { orderReducer } = state;

    return {
      Order: orderReducer.Order && orderReducer.Order.data,
      oneuser: orderReducer.oneuser,
    };
  });

  React.useEffect(() => {
    // Fetching all users for athenuem
    fetchData();
  }, [status]);

  const fetchData = async () => {
    try {
      dispatch(
        getAllOrderAsync({
          params: {
            page: 1,
            limit: 10,
            status: status,
          },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Users have been fetched.');
        });
    } catch (error) {
      toast.error('Users could not be fetched, please try after some time.');
    }
  };

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getAllOrderAsync({
          params: { page: val, limit: 10, status: status },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All offers were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
  };

  return (
    <Box>
      {/* <Button onClick={handleOpen} variant="contained" color="primary">
        Add Order
      </Button> */}
      <Box my={4}>
        <Box mb={2}>
          <BuzzSelect
            width={180}
            name="status"
            size={'small'}
            placeholder={'Select Status'}
            value={status}
            onChange={handleStatus}
            label="Select Status"
            valueKey="value"
            labelKey="label"
            options={STATUS_OPTION}
          />
        </Box>
        <BuzzTable columns={orderColumn} data={Order && Order.fetchedOrders} />
        <Box display="flex" justifyContent="center">
          <BuzzPagination
            onClick={handlePageChange}
            total={Order && Order.count}
            pageNo={page}
            defaultPage={1}
            perPage={10}
          />
        </Box>
      </Box>
      {/* <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <AddOrderForm fetchDefaultData={fetchData} handleClose={handleClose} />
      </Modal> */}
    </Box>
  );
};

export default Orders;
